import { ref } from 'vue'

const usePagination = (_pageSize = 10, _totalSize = 0, _currentPage = 1) => {
  const pageSize = ref(_pageSize)
  const currentPage = ref(_currentPage)
  const totalSize = ref(_totalSize)

  const handleUpdate = (val) => {
    pageSize.value = val
    currentPage.value = 1
  }
  const handleCurrentPageChange = (page) => {
    currentPage.value = page
  }

  return {
    pageSize,
    currentPage,
    totalSize,
    handleUpdate,
    handleCurrentPageChange,
  }
}

export default usePagination
